import { useState } from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { PageLoading, EmptyState, Tabs, TabsList, TabsTrigger, TabsContent } from "@dosa/ui";
import type { ReportAudience } from "@dosa/types";
import { generateMedicationManagementReport } from "../../lib/api-client";
import { MedicationReportView } from "../../components/report/MedicationReportView";

export function PharmacistReportPage() {
  const { assessmentId } = useParams<{ assessmentId: string }>();
  const [audience, setAudience] = useState<ReportAudience>("CLINICAL");

  const { data: report, isLoading } = useQuery({
    queryKey: ["report", assessmentId],
    queryFn: () => generateMedicationManagementReport(assessmentId!),
    enabled: !!assessmentId,
  });

  if (isLoading) return <PageLoading />;
  if (!report) return <EmptyState title="Report not found" />;

  return (
    <div className="space-y-6">
      <Tabs value={audience} onValueChange={(v) => setAudience(v as ReportAudience)}>
        <TabsList>
          <TabsTrigger value="CLINICAL">Clinical version</TabsTrigger>
          <TabsTrigger value="PATIENT_FRIENDLY">Patient-friendly version</TabsTrigger>
        </TabsList>
        <TabsContent value="CLINICAL">
          <MedicationReportView report={report} audience="CLINICAL" />
        </TabsContent>
        <TabsContent value="PATIENT_FRIENDLY">
          <MedicationReportView report={report} audience="PATIENT_FRIENDLY" />
        </TabsContent>
      </Tabs>
    </div>
  );
}
